/*
  One-click extras: the Add button on each card, on the product page and in
  the cart.

  One listener on the document for every button, rather than one per
  button, so the row costs the same however many cards it has, and cards
  that arrive with a redraw of the cart work without being wired up.

  A tap adds that card's variant to the cart in the background, marked
  with a hidden _upsell property so orders can show what came from here,
  then turns the button into its added state and shows the new cart: on
  the cart page the page redraws itself, anywhere else the drawer opens
  with the new cart in it. Their own sections come back with the same
  request, so no second one is needed.

  With neither on the page, the cart page is opened instead. When the cart
  refuses, Shopify's own reason is shown under the row, which is specific
  and already in the shop's language. Anything else, a lost connection for
  one, shows the row's own error text, never the browser's message, which
  is in English whatever the shop's language.
*/
(() => {
  if (window.productUpsellReady) return;
  window.productUpsellReady = true;

  async function add(button) {
    const holder = button.closest('[data-upsell]');
    const error = holder ? holder.querySelector('[data-upsell-error]') : null;
    const cart = document.querySelector('cart-page') || document.querySelector('cart-drawer');

    if (error) error.hidden = true;
    button.setAttribute('aria-busy', 'true');

    const body = new FormData();
    body.append('id', button.dataset.variantId);
    body.append('quantity', '1');
    body.append('properties[_upsell]', '1');

    if (cart && cart.getSectionsToRender) {
      body.append('sections', cart.getSectionsToRender().map((section) => section.id));
      body.append('sections_url', window.location.pathname);
    }

    let reason = '';

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body,
      });
      const result = await response.json();

      if (result.status) {
        reason = result.description || '';
        throw new Error('refused');
      }

      button.classList.add('is-added');
      button.disabled = true;
      if (holder && holder.dataset.addedLabel) button.textContent = `${holder.dataset.addedLabel} \u2713`;

      if (cart && cart.renderContents) cart.renderContents(result);
      else window.location.href = window.routes.cart_url;
    } catch (failure) {
      if (error) {
        error.textContent = reason || (holder ? holder.dataset.error : '');
        error.hidden = !error.textContent;
      }
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-upsell-add]');
    if (!button || button.disabled || button.hasAttribute('aria-busy')) return;

    add(button);
  });
})();
